import * as React from "react";
import { useParams } from "react-router";
import PageContents from "../components/layouts/PageContents";
import ManageProjectUsersContainer from "../containers/ManageProjectUsersContainer";

const ProjectUsersPage: React.FC = () => {
    const [title, setTitle] = React.useState("User access");
    const [subtitle, setSubtitle] = React.useState(
        "Please wait while we retrieve the project information..."
    );
    const [isForbidden, setIsForbidden] = React.useState(false);
    const { projectId } = useParams();

    return (
        <PageContents
            title={title}
            subtitle={subtitle}
            isForbidden={isForbidden}
            variant="small"
        >
            <ManageProjectUsersContainer
                projectId={projectId!}
                setTitle={setTitle}
                setSubtitle={setSubtitle}
                setIsForbidden={setIsForbidden}
            />
        </PageContents>
    );
};

export default ProjectUsersPage;
